<template>
  <div class="container pb-3">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HeaderSection',
}
</script>
